import { Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, IsUUID, ValidateIf, ValidateNested } from 'class-validator';
import { SopRelationshipDto } from '../complaints-process-config/sop-relationship.dto';

export class CreateRecallProcessConfigRequestDto {
    /**
     * Emergency Contact 1 ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsOptional()
    @ValidateIf((o) => o.emergencyContact1Id !== '' && o.emergencyContact1Id != null)
    @IsUUID()
    emergencyContact1Id?: string;

    /**
     * Emergency Contact 2 ID
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @IsOptional()
    @ValidateIf((o) => o.emergencyContact2Id !== '' && o.emergencyContact2Id != null)
    @IsUUID()
    emergencyContact2Id?: string;

    /**
     * Reporting to HC Contact ID
     * @example '123e4567-e89b-12d3-a456-426614174002'
     */
    @IsOptional()
    @ValidateIf((o) => o.reportingToHcContactId !== '' && o.reportingToHcContactId != null)
    @IsUUID()
    reportingToHcContactId?: string;

    /**
     * Follow-up to HC Contact ID
     * @example '123e4567-e89b-12d3-a456-426614174003'
     */
    @IsOptional()
    @ValidateIf((o) => o.followUpToHcContactId !== '' && o.followUpToHcContactId != null)
    @IsUUID()
    followUpToHcContactId?: string;

    /**
     * Notes
     * @example 'Emergency recall procedures'
     */
    @IsOptional()
    @IsString()
    notes?: string;

    @IsOptional()
    @IsArray()
    sops?: SopRelationshipDto[];
}
